// extracted by mini-css-extract-plugin
export default {"header":"Header_header__X7S2o","container":"Header_container__d2lO+","logo":"Header_logo__gcvD+","delimiter":"Header_delimiter__H3r86"};